import { useRef, useState } from 'react';

const borner = (v) => Math.min(1, Math.max(0, v));

// Photo + 4 poignées à glisser sur les coins du document
export const EditeurCoins = ({ url, coins, onChange }) => {
  const ref = useRef(null);
  const [actif, setActif] = useState(null);
  const deplacer = (e) => {
    if (actif === null) return;
    const r = ref.current.getBoundingClientRect();
    onChange(coins.map((c, i) => (i === actif ? [borner((e.clientX - r.left) / r.width), borner((e.clientY - r.top) / r.height)] : c)));
  };
  const points = coins.map(([x, y]) => `${x},${y}`).join(' ');
  return (
    <div ref={ref} className="relative mx-auto w-fit touch-none select-none" onPointerMove={deplacer} onPointerUp={() => setActif(null)} onPointerCancel={() => setActif(null)} data-testid="editeur-coins">
      <img src={url} alt="Document photographié" draggable={false} className="block max-h-[58vh] max-w-full rounded-md" />
      <svg viewBox="0 0 1 1" preserveAspectRatio="none" className="pointer-events-none absolute inset-0 h-full w-full">
        <path d={`M0 0H1V1H0Z M${coins.map(([x, y]) => `${x} ${y}`).join(' L')}Z`} fillRule="evenodd" fill="rgba(15,23,42,0.55)" />
        <polygon points={points} fill="none" stroke="#8DC63F" strokeWidth="2.5" vectorEffect="non-scaling-stroke" />
      </svg>
      {coins.map(([x, y], i) => (
        <button key={i} type="button" aria-label={`Coin ${i + 1}`}
          onPointerDown={(e) => { e.preventDefault(); e.currentTarget.setPointerCapture?.(e.pointerId); setActif(i); }}
          style={{ left: `${x * 100}%`, top: `${y * 100}%` }}
          className={`absolute h-10 w-10 -translate-x-1/2 -translate-y-1/2 rounded-full border-[3px] border-[#8DC63F] shadow-lg transition-transform ${actif === i ? 'scale-125 bg-[#8DC63F]/50' : 'bg-white/40'}`}
          data-testid={`coin-${i}`} />
      ))}
    </div>
  );
};
